const API_URL = process.env.REACT_APP_API_BASE_URL || '';

/**
 * Owner API Service
 * Handles all owner-related API operations
 */
export class OwnerService {
    
    /**
     * Fetch all owners
     * @param {Function} authorizedFetch - Authenticated fetch function
     * @returns {Promise<Array>} Array of owners
     */
    static async getAllOwners(authorizedFetch) {
        const response = await authorizedFetch(`${API_URL}/api/owners`);
        
        if (!response.ok) {
            throw new Error(await response.text());
        }
        
        return response.json();
    }

    /**
     * Create a new owner
     * @param {Object} ownerData - Owner data to create
     * @param {Function} authorizedFetch - Authenticated fetch function
     * @returns {Promise<Object>} Created owner
     */
    static async createOwner(ownerData, authorizedFetch) {
        const response = await authorizedFetch(`${API_URL}/api/owners`, {
            method: 'POST',
            body: JSON.stringify(ownerData)
        });
        
        if (!response.ok) {
            throw new Error(await response.text());
        }
        
        return response.json();
    }

    /**
     * Update an existing owner
     * @param {string} ownerId - ID of owner to update
     * @param {Object} ownerData - Updated owner data
     * @param {Function} authorizedFetch - Authenticated fetch function
     * @returns {Promise<Object>} Updated owner
     */
    static async updateOwner(ownerId, ownerData, authorizedFetch) {
        const response = await authorizedFetch(`${API_URL}/api/owners/${ownerId}`, {
            method: 'PUT',
            body: JSON.stringify(ownerData)
        });
        
        if (!response.ok) {
            throw new Error(await response.text());
        }
        
        return response.json();
    }

    static async getOwner(ownerId, authorizedFetch) {
        const response = await authorizedFetch(`${API_URL}/api/owners/${ownerId}`);
        if (!response.ok) throw new Error(await response.text());
        return response.json();
    }

    /**
     * Delete an owner
     * @param {string} ownerId - ID of owner to delete
     * @param {Function} authorizedFetch - Authenticated fetch function
     * @returns {Promise<void>}
     */
    static async deleteOwner(ownerId, authorizedFetch) {
        const response = await authorizedFetch(`${API_URL}/api/owners/${ownerId}`, {
            method: 'DELETE'
        });
        
        if (!response.ok) {
            throw new Error(await response.text());
        }
    }
}
